import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/home/Home.vue';
import BrandStory from '@/views/brandstory/BrandStory.vue';
import Products from '@/views/product/Products.vue';
import ProductDetail from '@/views/product/detail/ProductDetail.vue';
import BrandFilm from '@/views/brandfilm/BrandFilm.vue';
import News from '@/views/news/main/News.vue';
import NewsDetail from '@/views/news/detail/NewsDetail.vue';
import Sns from '@/views/sns/Sns.vue';
import Srch from '@/views/srch/Srch.vue';
import Error404 from '@/components/error/Error404.vue';

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/brandstory',
    name: 'BrandStory',
    component: BrandStory,
  },
  {
    path: '/products',
    name: 'Products',
    component: Products,
  },
  {
    path: '/products/:productId',
    name: 'ProductDetail',
    component: ProductDetail,
    props: (route) => ({ productId: route.params.productId }),
  },
  {
    path: '/brandfilm',
    name: 'BrandFilm',
    component: BrandFilm,
  },
  {
    path: '/news',
    name: 'News',
    component: News,
  },
  {
    path: '/news/detail/:newsId',
    name: 'NewsDetail',
    component: NewsDetail,
    props: (route) => ({ newsId: route.params.newsId }),
  },
  {
    path: '/sns',
    name: 'sns',
    component: Sns,
  },
  {
    path: '/search',
    name: 'Srch',
    component: Srch,
  },
  {
    path: '*',
    component: Error404,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  // eslint-disable-next-line no-undef
  gtag('config', window.gtagInfo.id, { page_path: to.fullPath });
  next();
});

export default router;
